export function getTabContentId(tabName) {
  return `tournament_${tabName.toLowerCase()}`;
}

export function getTabId(tabName) {
  return `tab_tournament_${tabName.toLowerCase()}`;
}
